// MANAGE FILTERS BEHAVIOR ON RESIZE.
window.addEventListener('resize', function () {
    removeOpen()
    isMobile()
})

function removeOpen() {
    document.querySelector('body').classList.remove('is-open')
}

function isMobile() {
    if (window.matchMedia('(min-width: 992px)').matches) {
        document.querySelector('body').classList.remove('is-mobile')
        document.querySelector('body').classList.add('is-desktop')
    } else {
        document.querySelector('body').classList.add('is-mobile')
        document.querySelector('body').classList.remove('is-desktop')
    }
}
